import {RootState} from 'App/store/rootReducer';

import type {TInteriorDesignResultData, TInteriorTableState} from './types';

export const selectOutput =
  () =>
  (state: RootState): TInteriorDesignResultData | null =>
    state.map3DEntities.interiorDesign.output;

export const selectApplyToAll =
  () =>
  (state: RootState): boolean =>
    state.map3DEntities.interiorDesign.applyToAll;

export const selectTables =
  () =>
  (state: RootState): TInteriorTableState | null =>
    state.map3DEntities.interiorDesign.tables;
